// Role: Technician.
// Description: Patient page with info.
import React from 'react';
import { Col, Paper, PageWrapper, Row } from 'virtues-bootstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import { Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';

import SidebarPatientInfo from 'containers/SidebarPatientInfo';
import SidebarRecentReports from 'containers/SidebarRecentReports';
import TechniciansPatientInfo from 'containers/PatientInfo/TechniciansPatientInfo';

import SegmentedNav from 'components/SegmentedNav';

import TechnicianPatientPageContent from 'containers/TechnicianPatientPage/Content';

const TechnicianPatientPage = ({ isDeviceTechnician, match }) => (
  <PageWrapper>
    <SegmentedNav
      items={[
        {
          to: `/patient/${match.params.id}/device-information`,
          transKey: 'patientNavigation.deviceInformation',
        },
        {
          to: `/patient/${match.params.id}/transmission-report`,
          transKey: 'patient.transmissionReport',
        },
      ]}
    />
    <Row>
      <Col xs={4}>
        <Paper>
          <TechniciansPatientInfo id={match.params.id} />
          <Switch>
            {isDeviceTechnician && (
              <Route path="/patient/:id/device-information" component={SidebarPatientInfo} />
            )}
            <Route path="/patient/:id/transmission-report" component={SidebarRecentReports} />
          </Switch>
        </Paper>
      </Col>
      <Col xs={8}>
        <TechnicianPatientPageContent />
      </Col>
    </Row>
  </PageWrapper>
);

TechnicianPatientPage.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
  isDeviceTechnician: PropTypes.bool.isRequired,
};

export default TechnicianPatientPage;
